import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { UserService } from '../services/user.service';
import { AccessSections } from '../classes/user';
import { SharedService } from '../services/shared.service';

@Injectable({
  providedIn: 'root',
})
export class AuthorizeGuard implements CanActivate {
  subscription: any;
  access_sections: AccessSections
  
  constructor(public router: Router, private userService: UserService, private sharedService: SharedService) {}
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const currentUser = this.userService.getCurrentUser()
    if (currentUser) {
      if(state.url === '/dashboard' || state.url.startsWith('/dashboard/')){
        return true;
      }

      if(currentUser.ruolo == 0){
        this.router.navigateByUrl('/login');
        return false;
      }
      if(currentUser.ruolo == 2){
        // Consento l'accesso solo alla rotta dei real matches
        const allowedPaths = [
          /^\/real_match\/list$/,
          /^\/real_match\/\d+\/table$/,
          /^\/real_match\/\d+$/,
          /^\/dashboard\/\d%/,
        ];
        const isAllowed = allowedPaths.some(pattern => pattern.test(state.url));
        console.log("allowed: ", isAllowed)
        if(isAllowed){
          return true;
        }
        
        // Se non è un percorso consentito, reindirizza
        this.router.navigateByUrl('/login');
        return false;
      }
      return true;
    }
    this.router.navigateByUrl('/login');
    return false;
  }

  getAuthAccess(){
    this.subscription = this.userService.getAuthAccesstoSections().subscribe({
      next: (data) => {
        this.access_sections = data.payload
        this.sharedService.setAccess(this.access_sections);
      },
      error: (err) => console.log('ERRORE: ' + JSON.stringify(err.error.description)),
    })
  }
}
